<script lang="ts">
	export let margin = "mt-12"
</script>

<div class="rich-text max-w-none p-8 {margin} text-2xl bg-stone text-center rounded-xl">
	<slot />
</div>